import styled from "styled-components";
import { navigate } from "../../services";
import { logo } from "../../images";

export const Logo = styled.img.attrs({
    src: logo,
    onClick: () => () => navigate.to("/app/docs"),
})`
    user-select: none;
    cursor: pointer;
    position: fixed;
    left: 25px;
    bottom: 20px;
    width: 40px;
`;
